import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=4f28cece&scoped=true&"
import script from "./MainBanner.vue?vue&type=script&lang=js&"
export * from "./MainBanner.vue?vue&type=script&lang=js&"
import style0 from "./MainBanner.vue?vue&type=style&index=0&id=4f28cece&scoped=true&lang=less&"
import style1 from "./MainBanner.vue?vue&type=style&index=1&lang=less&"
import style2 from "./MainBanner.vue?vue&type=style&index=2&id=4f28cece&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28cece",
  null
  
)

export default component.exports